export default __webpack_public_path__ + "static/kr1-c76998d0e57646825eb6456e3d2b8e26.png";